import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { DisplayButton } from '@xo-union/tk-ui-links';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import EventCollection from '~/glm/models/gds/event-collection';
import EventSelectorItem from '~/glm/components/guest-list/header/glm-header/event-selector-item';
import AnalyticsStore from '~/glm/models/analytics-store';
import GuestListStore from '~/glm/models/guest-list-store';
import UserStore from '~/glm/models/user-store';
import GdsEventModel from '~/glm/models/gds/gds-event-model';
import { EventModal, ScheduleOfEventsModal } from '../../../../../libs/component-event-modal';
import styles from './event-selector.scss';

@observer
class EventSelector extends React.Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    gdsEvents: PropTypes.instanceOf(EventCollection).isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
    guestListStore: PropTypes.instanceOf(GuestListStore).isRequired,
    userStore: PropTypes.instanceOf(UserStore).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { addEventModalOpen: false };
  }

  closeModal = () => {
    this.setState({ addEventModalOpen: false });
  };

  openAddEventModal() {
    const { analyticsStore } = this.props;
    this.setState({ addEventModalOpen: true });
    analyticsStore.track('Dashboard Interaction', {
      action: 'add event initiated',
      source: 'glm header',
    });
  }

  onSuccess = updatedEvent => {
    try {
      if (!updatedEvent) return null;

      const { gdsEvents } = this.props;

      const params = {
        ...updatedEvent,
        fullAddress: { ...updatedEvent.location },
        locationName: get(updatedEvent, ['location', 'name']),
      };
      const newEvent = new GdsEventModel(params);
      gdsEvents.add(newEvent);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  };

  onHideDate = hideDate => {
    this.props.userStore.updateHideDate(hideDate);
  };

  render() {
    const { gdsUiState, gdsEvents, analyticsStore, guestListStore, userStore } = this.props;

    const addEventLinkClassNames = [styles.link, styles.addEventLink].join(' ');

    return (
      <Fragment>
        <ul className={styles.eventList}>
          <EventSelectorItem gdsUiState={gdsUiState} analyticsStore={analyticsStore} />
          {gdsEvents.nonReceptionEvents.map(e => (
            <EventSelectorItem key={e.id} gdsUiState={gdsUiState} analyticsStore={analyticsStore} event={e} />
          ))}
          <li>
            <DisplayButton
              color="primary"
              className={addEventLinkClassNames}
              onClick={() => this.openAddEventModal()}
              data-testid="new-event-add"
            >
              + New Event
            </DisplayButton>
          </li>
        </ul>
        {guestListStore &&
          guestListStore.guestWedding &&
          (guestListStore.guestWedding.usesSubEvents ? (
            <ScheduleOfEventsModal
              usesQuestions={guestListStore.guestWedding.usesQuestions}
              open={this.state.addEventModalOpen}
              setClose={this.closeModal}
              weddingId={guestListStore.guestWedding.id}
              event={null}
              hasWWS={userStore.hasWWS}
              type="WeddingEvent"
              onSuccess={this.onSuccess}
              hideDate={userStore.hideDate}
              onHideDate={this.onHideDate}
            />
          ) : (
            <EventModal
              usesQuestions={guestListStore.guestWedding.usesQuestions}
              open={this.state.addEventModalOpen}
              setClose={this.closeModal}
              weddingId={guestListStore.guestWedding.id}
              event={null}
              hasWWS={userStore.hasWWS}
              type="WeddingEvent"
              onSuccess={this.onSuccess}
              hideDate={userStore.hideDate}
              onHideDate={this.onHideDate}
            />
          ))}
      </Fragment>
    );
  }
}

export default EventSelector;
